<template>
  <div class="col-md-11 visits__items">
    <div v-if="otherServicesCurrent.length === 0 || !otherServicesCurrent">
      <div class="not-found row mt-5">
        <div class="col-3 d-flex justify-content-end">
          <img src="~@/assets/images/zero-illu-01.svg" alt="">
        </div>
        <div class="col-7">
          <div class="mb-3" v-html="$t('other_service.empty.text')">
          </div>
        </div>
      </div>
    </div>

    <div class="visits__item row" v-for="otherServiceCurrent in otherServicesCurrent">
      <div class="date col-3">
        {{ formatDate(otherServiceCurrent.date_time) }}
        <span>{{ formatTime(otherServiceCurrent.date_time) }}</span>
      </div>

      <div class="col-5">
        <div class="text">{{ otherServiceCurrent.name }}</div>
      </div>
      <div class="text col-4">
        {{ getClinicName(otherServiceCurrent) }}
      </div>
      <div class="delimiter w-100"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import config from '@/helpers/configDateFormats';

export default {
  name: 'other-services-current',
  data() {
    return {
      selectedVisitCurrentCancel: null,
    };
  },
  computed: {
    ...mapGetters({
      otherServicesCurrent: 'otherServicesCurrent',
      clinics: 'clinics'
    }),
  },
  methods: {
    formatTime(date) {
      return moment(date).format(config.TIME_FORMAT);
    },
    formatDate(date) {
      return moment(date).format(config.DATE_FORMAT_OUTPUT);
    },
    getClinicName(visit) {
      let visitClinic = this.clinics.filter((item) => item.id === visit.clinic)
      if (visitClinic.length > 0) {
        return visitClinic[0].address
      }
      return ''
    },
  }
}
</script>
